import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import carIocn from "../../assets/images/car.png";
import car1 from "../../assets/images/1.png";
import car2 from "../../assets/images/2.png";
import car3 from "../../assets/images/3.png";
import car4 from "../../assets/images/4.png";  
import { Link } from 'react-router-dom';
export default function Services() {
  return (
    <div>
      <div className="services-one pb-0">
        <div className="services-one__shape-1"></div>
        {/* <div className="services-one__shape-2"></div> */}
        {/* your actual content here */}
        <Container>
          <div className="section-title mb-4">
            <img src={carIocn} alt="" />
            <h2>Services We’re Providing to Customers</h2>
          </div>
          <Row>
            <Col xs={12} sm={6} md={4} lg={3}>
              <div className="services_single">
              <Link to="/corporate-car-rental">
                <div className="mb-2">
                  <img src={car1} alt="" />
                </div>
                <h5>Corporate car rental</h5>
                <p>Our Corporate Car Rental Service in Varanasi is specially designed to meet the professional travel needs...</p>
                </Link>
              </div>
            </Col>
            <Col xs={12} sm={6} md={4} lg={3}>
              <div className="services_single">
              <Link to="/car-rental-with-driver">
                <div className="mb-2">
                  <img src={car2} alt="" />
                </div>
                <h5>Car rental with driver</h5>
                <p>Looking for a reliable car rental with driver in Varanasi? We offer professional chauffeur-driven car...</p>
                </Link>
              </div>
            </Col>
            <Col xs={12} sm={6} md={4} lg={3}>
              <div className="services_single">
              <Link to="/airport-transfer">
                <div className="mb-2">
                  <img src={car3} alt="" />
                </div>
                <h5>Airport transfer</h5>
                <p>We provide reliable and punctual airport transfer service in Varanasi for tourists, business travelers,...</p>
                </Link>
              </div>
            </Col>
            <Col xs={12} sm={6} md={4} lg={3}>
              <div className="services_single">
              <Link to="/fleet-leasing">
                <div className="mb-2">
                  <img src={car4} alt="" />
                </div>
                <h5>Fleet leasing</h5>
                <p>
                  Our Fleet Leasing Service in Varanasi offers reliable and cost-effective vehicle leasing solutions...
                </p>
                </Link>
              </div>
            </Col>
          </Row>
        </Container> 
      </div>
    </div>
  )
}
